import { render, staticRenderFns } from "./FixedBlockControl.vue?vue&type=template&id=af1ae77c&"
import script from "./FixedBlockControl.vue?vue&type=script&lang=js&"
export * from "./FixedBlockControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports